"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useService = void 0;
const react_1 = require("react");
const utils_1 = require("./utils");
const types_1 = require("./types");
const INITIAL_STATE = {
    status: types_1.ServiceStatusType.INITIAL,
};
const useService = (asyncFn) => {
    const [state, setState] = (0, react_1.useState)(INITIAL_STATE);
    const reset = (0, react_1.useCallback)(() => setState(INITIAL_STATE), []);
    const call = (0, react_1.useCallback)(async (...args) => {
        setState(prev => ({ ...prev, status: types_1.ServiceStatusType.LOADING }));
        const { err, response, isSuccess } = await (0, utils_1.parseResponse)(asyncFn(...args));
        if (isSuccess) {
            setState({
                data: response,
                status: types_1.ServiceStatusType.SUCCESS,
            });
        }
        else {
            setState({
                error: err,
                status: types_1.ServiceStatusType.ERROR,
            });
        }
    }, []);
    return {
        call,
        reset,
        ...state,
    };
};
exports.useService = useService;
//# sourceMappingURL=useService.hook.js.map